<template>
    <select v-model="sort" name="sort-dropdown" @change="handleChange">
        <option :value="{}" selected>{{ translations.sortText }}</option>
        <option :value="{sortBy: 'price_per_day', order: 'asc'}">{{ translations.priceAscText }}</option>
        <option :value="{sortBy: 'price_per_day', order: 'desc'}">{{ translations.priceDescText }}</option>
    </select>
</template>

<script>
import translations from "../mixins/translations";

export default {
    name: "SortDropdown",

    mixins: [translations],

    data() {
        return {
            sort: {sortBy: 'price_per_day', order: 'asc'}
        }
    },

    methods: {
        handleChange() {
            this.$emit('change', this.sort);
        }
    }
}
</script>